import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { ContactForm } from '@metlas/contact';
import styles from './BuildingIntelligence.module.css';

const BuildingIntelligenceExpediter: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    // Defer to the next frame so the entrance transition animates from the
    // initial state — and so the flip isn't a synchronous setState in the
    // effect body (which would cascade renders).
    const raf = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(raf);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const savedVolume = localStorage.getItem('videoVolume');
    if (savedVolume !== null) {
      const v = parseFloat(savedVolume);
      if (!isNaN(v) && v >= 0 && v <= 1) video.volume = v;
    }

    const handleVolumeChange = () => {
      localStorage.setItem('videoVolume', String(video.volume));
    };
    video.addEventListener('volumechange', handleVolumeChange);
    return () => video.removeEventListener('volumechange', handleVolumeChange);
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.bg}>
        <div className={`${styles.nebula} ${styles.nebula1}`} />
        <div className={`${styles.nebula} ${styles.nebula2}`} />
        <div className={`${styles.nebula} ${styles.nebula3}`} />
      </div>

      <div className={`${styles.content} ${isVisible ? styles.visible : ''}`}>
        <nav className={styles.nav}>
          <Link to="/" className={styles.back}>
            ← Back to Metlas
          </Link>
        </nav>

        <section className={styles.hero}>
          <h1 className={styles.headline}>
            Building Intelligence, pin and chat with all historical information you need in one dossier
          </h1>
          <a href="/apps/expediter-building-intelligence/" className={styles.tryBtn}>
            Try it out →
          </a>
        </section>

        <section className={styles.caseStudy}>
          <div className={styles.videoWrapper}>
            <video
              ref={videoRef}
              className={styles.video}
              src="/videos/building_intellegence_demo_expediters.mp4"
              autoPlay
              loop
              muted
              playsInline
              controls
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </section>
      </div>

      <aside className={styles.contactFloat}>
        <ContactForm variant="float" />
      </aside>
    </div>
  );
};

export default BuildingIntelligenceExpediter;
